<breadcrumb [endText]="endText" [navigations]="breadcrumbNav" />
<save-popup [show]="openSaveDialog" />
<error-dialog [show]="openErrorDialog" [error]="errorDialogText" />
@if (openExitDialog) {
<div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60">
  <div class="h-full w-full">
    <div class="cancelDialog">
      <p class="font-bold z-10">Sure you want to leave?</p>
      <p class="mt-3 z-10">Your changes are not saved automatically and will be discarded if you exit now. Make sure to
        save your changes before you exit.</p>
      <fa-icon class="mt-3 z-10" [icon]="faTriangleExclamation" size="5x"></fa-icon>
      <div class="h-[38px] mt-5 flex flex-row z-10">
        <full-button [marginRight]="true" (click)="closeExitDialog()" text="Cancel" />
        <outline-button (click)="exitAgreement()" text="Exit Now" />
      </div>
      <fa-icon class="backgroundExit" [icon]="faTriangleExclamation" size="10x"></fa-icon>
    </div>
  </div>
</div>
}
<div class="m-8">
  <h1 class="text-xl mb-2 font-semibold">{{add? 'New' : 'Edit'}} User Agreement</h1>
  <hr />
  <div class="mt-4 2xl:w-3/5" [formGroup]="form">
    <div class="grid grid-cols-10">
      @if (add) {
      <p class="text-sm col-span-10 lg:col-span-8">Welcome to the new user agreement creation form. This form is
        designed to help you create a new user agreement that will be presented to users when they sign up or use our
        service. Please fill out the following fields with the relevant information for the new agreement. Required
        fields are marked with an asterisk <span [style]="primaryColor">(*)</span>. Please ensure that the information
        you provide is accurate and up-to-date.</p>
      }
      @if (!add) {
      <p class="text-sm col-span-10 lg:col-span-8">While editing the user agreement, it is important to carefully review
        any changes to ensure that the agreement remains clear, concise, and legally enforceable.</p>
      }
    </div>
    <div class="grid grid-cols-10 mt-8 h-[34px]">
      <b class="col-span-4">Title <span [style]="primaryColor">*</span></b>
      <input type="text" placeholder="example: Terms of Service title"
        class="col-span-6 lg:col-span-4 text-[12px] lg:text-[14px]" formControlName="title" id="title"
        (change)="changes()" />
    </div>
    <div class="grid grid-cols-10 mt-2">
      @if (form.get('title')?.touched && form.get('title')?.invalid) {
      <p class="col-span-10 lg:col-span-8 text-sm text-red-500 font-semibold">Title is required.</p>
      }
      <p class="col-span-10 lg:col-span-8 text-sm text-gray-500">This title will be displayed to users when they are
        presented with the agreement, so it should accurately reflect the contents and purpose of the agreement.</p>
    </div>
    <div class="grid grid-cols-10 mt-8 h-[128px]">
      <b class="col-span-4">Body <span [style]="primaryColor">*</span></b>
      <textarea placeholder="example: Body of Terms of Service" rows="4"
        class="col-span-6 lg:col-span-4 row-span-2 text-[12px] lg:text-[14px]" id="body" formControlName="body"
        (change)="changes()" maxlength="60000"></textarea>
    </div>
    <div class="grid grid-cols-10 mt-2">
      @if (form.get('body')?.touched && form.get('body')?.invalid) {
      <p class="col-span-10 lg:col-span-8 text-sm text-red-500 font-semibold">Body is required.</p>
      }
      <p class="col-span-10 lg:col-span-8 text-gray-500 text-sm">The body of the agreement should be clear, concise, and
        easy to understand for our users. It should include all relevant terms and conditions, and any other information
        that users need to be aware of when using our service. Please note that the body of the agreement will be
        presented to users when they sign up or use our service, so it should be written in a user-friendly and
        easy-to-read format.</p>
    </div>
    <div class="grid grid-cols-10 mt-8 h-[64px]">
      <b class="col-span-4">Notice Text <span [style]="primaryColor">*</span></b>
      <textarea placeholder="example: You are required to accept these terms & conditions to start using the platform."
        rows="2" class="col-span-6 lg:col-span-4 row-span-2 placeholder-[#E48E8E] text-[12px] lg:text-[14px]"
        formControlName="notice" id="notice" (change)="changes()"></textarea>
    </div>
    <div class="grid grid-cols-10 mt-2">
      @if (form.get('notice')?.touched && form.get('notice')?.invalid) {
      <p class="col-span-10 lg:col-span-8 text-sm text-red-500 font-semibold">Notice is required.</p>
      }
      <p class="col-span-10 lg:col-span-8 text-gray-500 text-sm">The notice text will be the red text underneath the
        body of the agreement. It should be short and concise notify that the user should read this agreement prior to
        either accepting or declining it.</p>
    </div>
    <div class="grid grid-cols-10 mt-8 h-[34px] items-center">
      <b class="col-span-2 lg:col-span-1">Mandatory</b>
      <div class="flex items-center ml-2 lg:ml-0">
        <input type="checkbox" [style]="checkboxStyle" formControlName="required" id="required" />
        <label class="text-[14px]">Yes</label>
      </div>
    </div>
    <div class="grid grid-cols-10 mt-2">
      <p class="col-span-10 lg:col-span-8 text-gray-500 text-sm">Please select whether you would like to make this user
        agreement mandatory for all users to accept before using our service. If you select 'Yes', users will be
        required to accept the agreement before they can access the service. If you select 'No', the agreement will be
        optional for users to accept.</p>
    </div>
    <div class="grid grid-cols-10 mt-8 h-[64px]">
      <div class="col-span-6"></div>
      <div class="col-span-4 lg:col-span-2 flex flex-row mt-8 mb-3 justify-end">
        <outline-button [marginRight]="true" (click)="exitDialog()" text="Exit" />
        <outline-button [marginRight]="true" (click)="preview()" text="Preview" />
        <full-button (click)="save()" text="Save" />
      </div>
    </div>
  </div>
</div>